import { createRouter, createWebHistory } from 'vue-router';
// 按需引入
import adminRoutes from './adminRoutes';
import publicRoutes from './publicRoutes';

// 你可以通过环境变量、入口文件等方式，分别 export 只需要的 routes
// 这里示例：全量合并（开发用），实际 prod build 应拆分
const routes = [
  ...adminRoutes,
  ...publicRoutes,
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('authToken');
  const needsPasswordChange = localStorage.getItem('needsPasswordChange') === 'true';
  const isAdminRoute = to.path.startsWith('/admin');

  if (to.meta.requiresAuth) {
    if (!isAuthenticated) {
      // 如果是后台管理路由，跳 /admin/ssoLogin
      if (isAdminRoute && to.name !== 'ssoLogin') {
        next({ name: 'ssoLogin' });
      } else {
        // 其它需要登录的路由走原有逻辑
        next({ name: 'theLogin' });
      }
    } else if (needsPasswordChange && to.name !== 'ChangePassword') {
      next({ name: 'ChangePassword' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;